export enum Controllers {
  DEALER = "dealer",
  AUTH = "auth",
  USER = "user",
  PERMISSION = "permission",
  ROLE = "role",
  SALES = "sales",
  CONFIG = "config",
  RETAILER = "retailer",
  SELLER = "seller",
  STAKEHOLDER = "stakeholder",
  DEVICE = "device",
  Storage = "storage",
  APP_INFO = "app-info",
  CACHE = "cache",
  DASHBOARD = "dashboard",
  CONTACT = "contact",
}

export interface StorageUploadPresignRequest {
  key: string;
  contentType: string;
  contentLength: number;
  duration: number;
}

export interface ApiResponse<T> {
  status: OperationStatus;
  message: string;
  data: T;
}

export interface ApiPageRequest<T> {
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: string;
  filter: T;
}

export interface PageResponse<T> extends ApiResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export enum OperationStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  BAD_CREDENTIALS = "BAD_CREDENTIALS",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  USER_INACTIVE = "USER_INACTIVE",
  USER_LOCKED = "USER_LOCKED",
  USER_EXPIRED = "USER_EXPIRED",
  CREDENTIALS_EXPIRED = "CREDENTIALS_EXPIRED",
  INVALID_TOKEN_IN_HEADER = "INVALID_TOKEN_IN_HEADER",
  ACCESS_DENIED = "ACCESS_DENIED",
  SESSION_EXPIRED = "SESSION_EXPIRED",
  OTP_REQUIRED = "OTP_REQUIRED",
  INVALID_OTP = "INVALID_OTP"
}
